module.exports = __webpack_public_path__ + "img/46cd9ef8cc55c12546d643051ef85d82.svg";